import { get } from "./api";
import routes from "./end-points";

export const courseApi = {
    initCoursePosterUrl: (courseId, width, height) => routes.course.initCoursePoster(courseId, width, height),
    initCourse: (courseId) => get(routes.course.initCourse(courseId)),
};
